<template>
<div>
  <facet-common-mobile-desktop
      :items="brands"
      facetname="brands"
      queryparam="brand"
      title="Бренды"
      :active="true"
      type="common"
  ></facet-common-mobile-desktop>

  <facet-common-mobile-desktop
      :items="novelty"
      facetname="Новинка"
      queryparam="Новинка"
      title="Новинка"
      :active="true"
      type="yesnow"
  ></facet-common-mobile-desktop>

  <facet-common-mobile-desktop
      :items="hit"
      facetname="Хит"
      queryparam="Хит"
      title="Хит"
      :active="true"
      type="yesnow"
  ></facet-common-mobile-desktop>

  <facet-common-mobile-desktop
      :items="availability"
      facetname="Наличие"
      queryparam="Наличие"
      title="Наличие"
      :active="true"
      type="yesnow"
  ></facet-common-mobile-desktop>

  <facet-common-mobile-desktop
      :items="colors"
      facetname="Цвет"
      queryparam="Цвет"
      title="Цвет"
      :active="selected_category > 0"
      type="color"
  ></facet-common-mobile-desktop>

  <facet-common-mobile-desktop v-for="(tag, index) in tags" :key="slugify(tag.name)"
      :items="tag.values"
      :facetname="tag.name"
      :queryparam="tag.name"
      :title="tag.name"
      :active="selected_category > 0"
      type="common"
  ></facet-common-mobile-desktop>
</div>
</template>

<script>
import CyrillicToTranslit from 'cyrillic-to-translit-js';
import {mapGetters} from "vuex";
import FacetCommonMobileDesktop from "./facet-common-mobile-desktop.vue";

export default {
name: "facets",
  computed: {
    ...mapGetters("search", [
        "selected_category",
        "brandFacets",
        "tagFacets",
        "colorFacets",
        "noveltyFacets",
        "hitFacets",
        "availabilityFacets",
        "selectedFacets",
        "isMobile"
    ]),
    checkedBrands: {
      get: function () {
        return this.getCheckedArr('brands');
      },
      set: function (value) {}
    },
    checkedAvail: {
      get: function () {
        return this.getChecked('Наличие');
      },
      set: function (value) {}
    },
    checkedHit: {
      get: function () {
        return this.getChecked('Хит');
      },
      set: function (value) {}
    },
    checkedNovelty: {
      get: function () {
        return this.getChecked('Новинка');
      },
      set: function (value) {}
    },
    checkedColors: {
      get: function () {
        return this.getCheckedArr('Цвет');
      },
      set: function (value) {}
    },
    checkedFacets: {
      /**
       * {
       *  "Серия конструктора": [
           "Серия конструктора_Small Army",
           "Серия конструктора_World of Tanks"
         ],
         "Внешний вид": []
         }
       */
      get: function () {

        let tagFacets = this.tagFacets;
        let selectedFacets = this.selectedFacets;

        /**
         * преобразуем
         [
           {
              name: "Серия конструктора"
              value: ["World of tanks", "Boeind"]
           },
           {
              name: "Наличие",
              value: ["да"]
           }
         ]
          в массив вида:
         [
            {Серия конструктора: ["Серия конструктора_World of Tanks", ""Серия конструктора_Boeing""]},
            {Наличие: ["да"]}
         ]
         */
        const flatSelected = selectedFacets.map(function (item) {
          let ret = {};
          let v = item.value.map(function (vvv) {
            return item.name + '_' + vvv;
          })
          ret[item.name] = v;
          return ret;
        });

        // добавляем пустые массивы для невыбранных ключей
        tagFacets.forEach(function(facet) {
          let branch = flatSelected.filter(function (item) {
            return typeof item[facet.name] !== 'undefined';
          });
          if(branch.length === 0) {
            let newobj = {};newobj[facet.name] = [];
            flatSelected.push(newobj);
          }
        })

        // преобразуем объект объектов в массив объектов
        return Object.assign({}, ...flatSelected);
      },
      set: function (value){}
    },
    tags: {
      get: function () {
        return this.tagFacets;
      },
      set: function (value) {}
    },
    brands: function () {
      return this.brandFacets;
    },
    colors: function () {
      return this.colorFacets;
    },
    novelty: function () {
      return this.noveltyFacets;
    },
    hit: function () {
      return this.hitFacets;
    },
    availability: function () {
      return this.availabilityFacets;
    },
  },
  methods: {
    slugify: function (s) {
      const cyrillicToTranslit = new CyrillicToTranslit();
      return cyrillicToTranslit.transform(s, '_').toLowerCase();
    },
    getChecked(name) {
      let facet = this.selectedFacets.filter(function (item) {
        return item.name === name;
      });
      return (facet.length) ? facet[0].value[0]==='да' : false;
    },
    getCheckedArr(name) {
      let facet = this.selectedFacets.filter(function (item) {
        return item.name === name;
      });
      return (facet.length) ? facet[0].value : [];
    }
  },
  components: {
    FacetCommonMobileDesktop,
  }
}
</script>